import { MenuItems } from './MenuItems.js';
import { MENU_STYLES } from '../../constants/MenuConstants.js';

export class MenuStructure {
    constructor(model) {
        this.model = model;
        this.menuItems = new MenuItems(model);
    }

    updateMenuComponents(items) {
        try {
            const components = this.model.components();
            if (!components) {
                console.warn('Components collection not available');
                return;
            }

            let container = components.find(comp =>
                comp.getAttributes().class === 'menu-container'
            );

            if (!container) {
                this.createInitialMenuStructure(items);
            } else {
                this.updateExistingMenuStructure(container, items);
            }
        } catch (error) {
            console.error('Error updating menu components:', error);
        }
    }

    createInitialMenuStructure(items) {
        const components = this.model.components();
        components.reset();

        if (!items || items.length === 0) {
            this.createEmptyMenuPlaceholder(components);
            return;
        }

        const container = this.createMenuContainer(components);
        const ul = this.createMenuList(container);
        this.menuItems.populateMenuItems(ul, items);
    }

    createEmptyMenuPlaceholder(components) {
        components.add({
            tagName: 'div',
            attributes: { class: 'menu-placeholder' },
            content: 'No menu items available',
            style: MENU_STYLES.placeholder
        });
    }

    createMenuContainer(components) {
        return components.add({
            tagName: 'div',
            attributes: { class: 'menu-container' },
        });
    }

    createMenuList(container) {
        return container.components().add({
            tagName: 'ul',
            attributes: {
                class: 'menu-list',
                'data-menu-level': this.model.getMenuLevel()
            },
            style: MENU_STYLES.menuList
        });
    }

    updateExistingMenuStructure(container, items) {
        if (!container.components || typeof container.components !== 'function') {
            return;
        }

        let ul = container.components().find(comp =>
            comp.getAttributes().class &&
            comp.getAttributes().class.includes('menu-list')
        );

        if (!ul) {
            ul = this.createMenuList(container);
        }

        ul.addAttributes({ 'data-menu-level': this.model.getMenuLevel() });
        this.menuItems.updateMenuItemsConditionally(ul, items);
    }
}